/**
 * The action composer's search params. Both addresses the composer answers on
 * declare them, so a link into it keeps them through validation and through
 * the forward between the two addresses.
 *
 * - `tab` — which section of the composer to show. The create or update
 *   person composer has no sections and leaves it in the URL.
 * - `initiationType` — how the reader got here, which the composer's analytics
 *   report. Links from the workflow and elsewhere carry it.
 * - `overview`, `step`, `refreshLanguages`, `refreshTemplate`, `preset` and
 *   `editors` — cues the embedded composer reads for the other action types.
 *   They pass through untouched, so a forward to or from the `journeys`
 *   address hands them on.
 *
 * Nothing here rejects or coerces a value: an unrecognised cue must leave the
 * composer rendering rather than bounce the reader off the URL, and the router
 * writes back whatever this returns.
 */
export type ComposerSearch = {
  /** The composer section to show. */
  tab?: unknown;
  /** How the reader got here, for analytics. */
  initiationType?: unknown;
  overview?: unknown;
  step?: unknown;
  refreshLanguages?: unknown;
  refreshTemplate?: unknown;
  preset?: unknown;
  /** Asks for the classic editors. */
  editors?: unknown;
};

/** Search as `validateSearch` receives it: whatever was in the URL. */
// oxlint-disable-next-line local-rules/no-unsafe-dictionary-type -- validateSearch is handed unparsed search input, and the pass-through carries those same unvalidated values
type UnvalidatedSearch = Record<string, unknown>;

/**
 * Returns the whole of what arrived, the composer's own params and the global
 * ones it does not own alike. Without the declaration TanStack drops the
 * params the route does not name.
 */
export function validateComposerSearch(search: UnvalidatedSearch): UnvalidatedSearch & ComposerSearch {
  return { ...search };
}
